/* eslint-disable */
import React from 'react'

import numeral from 'numeral'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { isEmpty, isUndefined, isNil } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { fetchingState } from './../../helpers/hocs.js'
import { bindActionCreators } from 'redux'

import { getLoggedUser, getSettingsInfo } from '../../selectors/user.js'
import { clearPaymentMethods } from '../../store/reducers/paymentMethods'
import { putBid, editBid, getBidInfo, clearBidInfo, getBidById, setBidData } from '../../store/reducers/lots/bid'
import { getLotName } from '../../selectors/lots.js'

import {getUserSettings} from '../../store/reducers/auth'

import { setPaymentData, removeUserPayment } from '../../store/reducers/paymentMethods'

import BidForm from './BidForm'
import BidPayments from './PaymentSelect'
import BidAgreement from './Agreement'
import LotBidAgree from './LotBidAgree'
import Signin from '../../containers/Signin'
import Loader from '../../components/OverlayLoader'

import ym from 'react-yandex-metrika';
import data from '../../store/reducers/i18n/data.js'

import { check } from '../../store/reducers/giftcards'

import { sendCheckout } from '../../helpers/tagManager'
import getCID from '../../helpers/getCID.js'
import NationalCards from '../NationalCards.jsx'

const BidSuccessComponent = () => (
  <h1 className='Signin__title Head'><FormattedMessage id='bid.bid_sent' /></h1>
)

const BidSuccess = _.compose(
  _.lifecycle({
    componentDidMount() {
      this.props.onSuccess && setTimeout(() => this.props.onSuccess(), 1000)
    }
  })
)(BidSuccessComponent)

const BidDenied = ({ info }) => (
  <h1 className='Signin__title Head'>{info.denied}</h1>
)

const BidConfirm = ({ info, proceed }) => ( //тектс соглашения при привязке карты
  <BidAgreement data={info.agreement} onProceed={proceed} />
)

const LotBidConfirm = ({ info, lotProceed }) => ( //тектс соглашения при привязке карты
  <LotBidAgree data={info.agreement} onLotProceed={lotProceed} />
)


const BidOverlay = ({
  user,
  lot,
  submitting,
  info = null,
  errors = {},
  isSubscribed,
  price,
  help,
  setBidData,
  bidId,
  count,
  submit,submitPayment, getGiftCardData, data, partPay, bidInputFocus, setBidInputFocus, onClickFunc, useGiftCard, checkProps, //setOneAgreement, //agreements,
  giftCardChecked, setGiftCardChecked,setAgreementOffer, agreementOffer, setAgreementGiftcard, agreementGiftcard, bidCount, setMindboxData,//setAgreements,
  ...props
}) => {
  return (
    <div className='Signin__body'>
      {!user && <span className='Signin__undertitle Text'><FormattedMessage id='bid.login_required' /></span>}
      {!user
        ? <Signin noBody />
	
	: ( !user.isPaymentSet && user.isPaymentSet
	    ? (
                <div className='SetBid-layout__right'>
                  <BidPayments error={errors.paymentMethod || errors.giftcard || errors.agreements } onChange={setBidData} sendBack={getGiftCardData} bidInputFocus={bidInputFocus} setBidInputFocus={setBidInputFocus}
                   fromPage={lot.price ? 'fixedLot' : 'auction'} useGiftCard={useGiftCard}
                   giftCardChecked={giftCardChecked} setGiftCardChecked={setGiftCardChecked} checkProps={checkProps} bidValue={data.bidValue} bidCount={data.bidCount}
                   setAgreementOffer={setAgreementOffer} agreementOffer={agreementOffer}
                   setAgreementGiftcard={setAgreementGiftcard} agreementGiftcard={agreementGiftcard}/>
                  <div style={{ marginTop: 24 }}>
                    {errors.paymentMethod && <div style={{ marginBottom: 12 }} className='Text'>{errors.paymentMethod}</div>}
                    {errors.giftcard && <div style={{ marginBottom: 12 }} className='Text'>{errors.giftcard}</div>}
                    {errors.agreements && <div style={{ marginBottom: 12 }} className='Text'>{errors.agreements}</div>}
                    {!isNil(info.bidSuccess) && info.statusText && <div style={{ marginBottom: 12 }} className='Text'>{info.statusText}</div>}
                    <button className='Region-submit' disabled={submitting} onClick={submit}><FormattedMessage id='regions.done' /></button>
                  </div>
                </div>
	    )
        : (
          <Loader isOrange loading={submitting}>
            <div className='SetBid-layout'>
              <div className='SetBid-layout__left'>{/*левая часть страницы Сделать ставку - сумма ставки, ошибка, чекбоксы анонимности ставки и отслеживания аукциона */}
                <BidForm error={errors.bidValue || info.errorText} isSubscribed={isSubscribed} minBid={lot.price ? 'false' : numeral(info.minValue).format('0,0')} 
                lotTitle={lot.meta.persons} price={lot.price} count={count} help={lot.help} 
                disabled={bidId && !isNil(info.bidSuccess)} currency={info.currency} onSubmit={submit} onClick={onClickFunc}/>
                {!lot.paymentRequired && (
                  <button className='Region-submit' disabled={submitting} onClick={submit}><FormattedMessage id='regions.done' /></button>
                )}

              </div>
              {lot.paymentRequired && (
                <div className='SetBid-layout__right'>
                  <BidPayments error={errors.paymentMethod || errors.giftcard || errors.agreements } onChange={setBidData} sendBack={getGiftCardData} bidInputFocus={bidInputFocus} setBidInputFocus={setBidInputFocus}
                   fromPage={lot.price ? 'fixedLot' : 'auction'} useGiftCard={useGiftCard} giftCardChecked={giftCardChecked} 
                   setGiftCardChecked={setGiftCardChecked} checkProps={checkProps} bidValue={data.bidValue} bidCount={data.bidCount}
                   setAgreementOffer={setAgreementOffer} agreementOffer={agreementOffer} setAgreementGiftcard={setAgreementGiftcard} agreementGiftcard={agreementGiftcard}/>
                  <div style={{ marginTop: 24 }}>
                    {errors.paymentMethod && <div style={{ marginBottom: 12 }} className='Text'>{errors.paymentMethod}</div>}
                    {errors.giftcard && <div style={{ marginBottom: 12 }} className='Text'>{errors.giftcard}</div>}
                    {errors.agreements && <div style={{ marginBottom: 12 }} className='Text'>{errors.agreements}</div>}
                    {!isNil(info.bidSuccess) && info.statusText && <div style={{ marginBottom: 12 }} className='Text'>{info.statusText}</div>}
                    <button className='Region-submit' disabled={submitting} onClick={submit}>
                      <FormattedMessage id='regions.done' />
                    </button>
                  </div>
                    <NationalCards classname='orange bid' />
                </div>
              )}
            </div>
          </Loader>
        )
	)
      }
    </div>
  )
}

const mapStateToProps = state => /*{console.log('data2', state.lots);return*/({
  user: getLoggedUser(state),
  userInfo: getSettingsInfo(state),
  lot: state.lots.single.data,
  info: state.lots.bid.meta,
  data: state.lots.bid.data,
  partPay: state.lots.bid.data.giftcardData.partPay,
  lotName: getLotName(state),
  ...state.giftcards//.checkProps,
})//}
const mapDispatchToProps = { getBidInfo, putBid, editBid, clearBidInfo, getBidById, setBidData, clearPaymentMethods, setPaymentData, check}
const mergeProps = (state, dispatch, { id, fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  setBidData: dispatch.setBidData,
  id,
  clearBidInfo: () => {
    dispatch.clearBidInfo()
    props.setErrors({})
    props.setForceSuccess(false)
    dispatch.clearPaymentMethods()
  },
  getBidInfo: async () => {
    await props.setFetching(true)
    if (props.bidId) await dispatch.getBidById(id, props.bidId)
    else await dispatch.getBidInfo(id)
    await props.setFetching(false)
  },
  putBid: async data => {

    await props.setSubmitting(true)
    let result
    if (props.bidId && !state.info.bidSuccess) result = await dispatch.editBid(id, props.bidId, data)
    else result = await dispatch.putBid(id, data)
    await props.setSubmitting(false)
	//Яндекс Метрика
	if (result === 200) {
	    ym('reachGoal', state.lot.alias);
	    console.log('Bid.jsx state.lot.alias',state.lot.alias);
	}
    return result
  },
  getGiftCardData:(field, value) => {
    if (field == 'number') props.setNumber(value)
    else props.setPin(value)
  },
  clearGiftCard:async () => {
    await props.setGiftcardData({
      'number': '', 
      'pin': ''
    })
    props.giftcardData = {}
    props.giftcardData.number = ''
    props.giftcardData.pin = ''
  },
  giftCardInsufficientFunds: async () => {
    
    dispatch.setBidData('giftcardData', {partPay: true})
  },
  onClickFunc: async () => {//из-за конфликта фокусов input двух компонентов, передача фокуса по клику на поле
    props.setBidInputFocus(true)
  },
  useGiftCard: async (p, noLoader = true,) => {
    if (props.number && props.pin) {
      let res = //noLoader ? 
      await dispatch.check({ 'number': props.number, 'pin': props.pin })
      //: await fetchingWrap(check.bind(this, { 'number': number, 'pin': pin }))
      if (res != 200) {
        //setError(true)
      } else {
        //setError(false)
      }
    }
  }
})

export default _.compose(
  injectIntl,
  _.withState('errors', 'setErrors', {}),
  _.withState('fetching', 'setFetching', false),
  _.withState('submitting', 'setSubmitting', false),
  _.withState('forceSuccess', 'setForceSuccess', false),
  //_.withState('giftcardData', 'setGiftcardData', {}),
  _.withState('number', 'setNumber', ''),
  _.withState('pin', 'setPin', ''),
  _.withState('bidInputFocus', 'setBidInputFocus', false),
  //fetchingState({ multi: true }),
  //_.withState('agreements', 'setAgreements', {offer: false, giftcard: false}),
  _.withState('agreementOffer', 'setAgreementOffer', false),
  _.withState('agreementGiftcard', 'setAgreementGiftcard', false),
  _.withState('giftCardChecked', 'setGiftCardChecked', false),
  _.withState('sendTags', 'setSendTags', {'checkout': false}),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  _.withHandlers({
    submit: ({ data, user, lot, putBid, info, setForceSuccess, setErrors, title, intl, giftcardData, setBidData, number, pin, 
      giftCardInsufficientFunds, partPay, giftCardChecked, checkProps, agreementOffer, agreementGiftcard, userInfo, setMindboxData }) => async e => {//Выбор метода оплаты - вызов функции по нажатию на кнопку Готово
	  if ((data.userPaymentId != null && data.userPaymentId != 'undefined' /*&& window.confirm(intl.formatMessage({id: 'bidPayment.confirm_pay_from_card'}))*/) || data.userPaymentId == null) {
      e && e.preventDefault()
      const cid = getCID()
	    if (!info || isUndefined(info.minValue)) return
	    const errors = {}
	    //проверка фиксированного лота, что бы не выводилось ссобщение об ошибке суммы
	    if (lot.price || lot.help){
        info.type = "fixLot";
	  	  info.minValue = 1
	    }
	    if (lot.paymentRequired && !data.paymentMethod && !data.userPaymentId) errors['paymentMethod'] = intl.formatMessage({ id: 'bid.choose_payment_method' })
	    if (!data.bidValue) errors['bidValue'] = intl.formatMessage({ id: 'bid.choose_bid' })
      if (data.bidValue < info.minValue) 
        errors['bidValue'] = <p>{intl.formatMessage({ id: 'bid.bid_too_small' })} <br></br>
        {info.minValue ? numeral(info.minValue).format('0,0') : 0} {info.currency.symbol}</p>
        

      if (giftCardChecked) {//используется подарочная карта
        if (!checkProps.error && checkProps.balance === 0) {
          errors.giftcard = <p>{intl.formatMessage({ id: 'bid.zero_giftcard' })}</p>
        } else if (checkProps.error || !checkProps.balance || checkProps.balance == 0) {
          errors.giftcard = intl.formatMessage({ id: 'bid.invalid_giftcard' })
        } else if (checkProps.balance >= (data.bidValue * Number(data.bidCount ? data.bidCount : 1))) {//подарочная карта полностью оплачивает ставку
          data.giftcardData = {
            'number': number, 
            'pin': pin, 
            'useGiftCard': true, 
            'partPay': false
          }
        } else if (checkProps.balance < (data.bidValue * Number(data.bidCount ? data.bidCount : 1))) {//частичная оплата подарочной картой
          if (data.paymentMethod && (data.paymentMethod != "giftcards")) {//выбрана оплата так же банковской картой
            data.giftcardData = {
              'number': number, 
              'pin': pin, 
              'useGiftCard': true, 
              'partPay': true
            },
            data.giftcardData.partPay = true
          } else {
            errors['paymentMethod'] = intl.formatMessage({ id: 'bid.choose_payment_method' })
          }
        }
      } else if (data.paymentMethod == 'giftcards'){
        errors['paymentMethod'] = intl.formatMessage({ id: 'bid.choose_payment_method' })
      }

      //нет согласия с пользовательским соглашением
      if (!agreementOffer || (giftCardChecked && !agreementGiftcard)) {
        errors.agreements = intl.formatMessage({ id: 'bid.accept_agreements_offer' })
        if (giftCardChecked && !agreementGiftcard) {
          errors.agreements += intl.formatMessage({ id: 'bid.accept_agreements_giftcards' })
        }
      }

	    if (!isEmpty(errors)) {
	  	  setErrors(errors)
	  	return null
      } else {
        setErrors({})
      }

      /*if (data.giftcardData) {
        data.giftcardData.useGiftCard = false;
      }
      //если указана оплата подарочной картой, то олжны быть ее данные
      if (lot.paymentRequired && data.paymentMethod == 'giftcards') {
        if (!number || !pin)
          return
        else {
          data.giftcardData = {
            'number': number, 
            'pin': pin, 
            'useGiftCard': true, 
            'partPay': false
          }
          let useGiftCard = true

        }
      }
      if (partPay) {
        if (!number || !pin || data.paymentMethod == "giftcards")
          return
        else {
          data.giftcardData = {
            'number': number, 
            'pin': pin, 
            'useGiftCard': true, 
            'partPay': partPay
          },
          data.giftcardData.partPay = true
        }
      }*/
      data.cid = cid

      const result = await putBid(data)

      if (result === 200) {
        setForceSuccess(true)
        if (user) {
          const countLots = Number(data.bidCount ? data.bidCount : 1)
          /*const mindboxData = {
            "customer": {
              "ids": {
                "websiteID": user._id
              },
              "email": userInfo.email,
            },
            "order": {
              "ids": {
                "websiteID": ''// сюда надо передавать bid.id после того как ставка будет сформирована
              },
              "customFields": {
                "anonymousbet": data.isAnonymous
              },
              "totalPrice": data.bidValue,
              "lines": [
                {
                  "basePricePerItem": lot.startBid,
                  "quantity": 1,
                  "product": {
                    "ids": {
                      "website": lot._id
                    }
                  }
                }
              ],
              "email": userInfo.email,
              "mobilePhone": userInfo.phone
            },
          }*/

          const mindboxData = {
            "customer": {
              "ids": {
                "websiteID": user._id
              },
              "email": userInfo.email,
              "mobilePhone": userInfo.phone,   
            },
            "order": {
              "ids": {
                "websiteID": ''// сюда надо передавать bid.id после того как ставка будет сформирована
              },
              "customFields": {
                "anonymousbet": data.isAnonymous,
                //  "bet": data.bidValue     
              },
              "payments": [],
              "lines": [
                {
                  //"basePricePerItem": lot.startBid,
                  "basePricePerItem": data.bidValue,
                  "quantity": 1,
                    "product": {
                    "ids": {
                      "website": lot._id
                    }
                  }
                }
              ],
            },
          }
          //если использовалась подарочная карта - добавим данные о ней
          if (number && number.length > 0) {
            /*mindboxData['order'].lines[0].discounts = [{
              "type": "promoCode",
              "promoCode": {
                "ids": {
                  "code": number ? number : ''
                }
              },
              "amount": number ? numeral((checkProps.balance >= (data.bidValue * countLots)) ? (data.bidValue * countLots) : checkProps.balance)._value : 0
            }]*/
            //добавляем данные для нового объекта данных по ставке
            mindboxData['order']['payments'] = [
              {
                "type": "Certificate",
                "id": checkProps._id/*number*/,
                "amount": number ? numeral((checkProps.balance >= (data.bidValue * countLots)) ? (data.bidValue * countLots) : checkProps.balance)._value : 0
              },
              {
                "type": "Card",
                "amount": data.bidValue,
                "creditCard": {
                  "hash": 144817532 //пока просто передаем фиксированное значение
                }
              }
            ]
          } else {
            mindboxData['order']['payments'] = [
              {
                "type": "Card",
                "amount": data.bidValue,
                "creditCard": {
                  "hash": 144817532 //пока просто передаем фиксированное значение
                }
              }
            ]
          }
          //передаем данные для отправки mindbox в компонент лота - там мы получим еще id ставки
          setMindboxData(mindboxData)
        }
      } else if (result === 406) {//недостаточно средств для оплаты
        //giftCardInsufficientFunds()
      }
	  
	  }
    },
    proceed: ({ info }) => () => {//когда соглашаешьс с соглашением
      if (info.redirectLink) window.location = info.redirectLink
    },
    lotProceed: ({ info }) => () => {//когда соглашаешьс с соглашением
      if (info.redirectLink) {
        window.location = info.redirectLink
      }
    },
    submitPayment: ({ data, lot, putBid, info, setForceSuccess, setErrors, title, intl }) => async e => {
      e && e.preventDefault()
      if (!info || isUndefined(info.minValue)) return
      const errors = {}
      if (lot.paymentRequired && !data.paymentMethod && !data.userPaymentId) errors['paymentMethod'] = intl.formatMessage({ id: 'bid.choose_payment_method' })

      if (!isEmpty(errors)) {
        setErrors(errors)
        return null
      }
      console.log('lot', lot)

      const result = await putBid(data)

      if (result === 200) setForceSuccess(true)

    },
    clearGiftCard2:({setGiftcardData, giftcardData}) => e => {
      setGiftcardData({number: '99999999', pin: '99'})
    },
  }),
  _.lifecycle({
    componentWillMount() {
    this.props.clearBidInfo()
      this.props.getBidInfo();

    },
    componentWillUnmount() {
      this.props.clearBidInfo()
    },
    componentDidUpdate(prevProps) {
      if (!prevProps.user && this.props.user) this.props.getBidInfo();
      if (this.props && !!this.props.info.redirectLink && !!this.props.onProceed || !this.props.info.type && !this.props.lot.specialBindingSum) {
        this.props.proceed()
      }
      // if (this.props && !!this.props.info.redirectLink && !!this.props.onLotProceed) {
      //   this.props.lotProceed()
      // }

      //открытие страницы Сделать ставку - отправка данных в tag manager
      if (this.props.info 
        && !(!!this.props.info.redirectLink && !!this.props.info.type )
        && !(!!this.props.info.redirectLink && !!this.props.lot.specialBindingSum )
        && !(this.props.fetching || !this.props.info) 
        && !(this.props.forceSuccess || (this.props.info.bidId && this.props.info.bidSuccess)) 
        && !this.props.denied
        && this.props.user
        && this.props.info.currency && this.props.lot && this.props.lot._id && this.props.lotName 
        && !this.props.sendTags.checkout//&& this.props.info.currency != prevProps.info.currency
        ) {
          this.props.setSendTags({...this.props.sendTags, checkout: true}) 
          sendCheckout({...this.props.lot, name: this.props.lotName}, this.props.count)
        }
    },
    componentWillReceiveProps(np) {
      console.log('какие у нас пропсы при ставке*************', np)
    }
  }),
  _.branch(({ info }) => info.denied, _.renderComponent(BidDenied)),
  _.branch(
    ({ forceSuccess, info }) => {return (forceSuccess || (info.bidId && info.bidSuccess))},
    _.renderComponent(BidSuccess)
  ),
  //_.branch(props => !!props.info.redirectLink, _.renderComponent(BidConfirm)),//рендер текста соглашения если есть redirectLink
  _.branch(props => (!!props.info.redirectLink && !!props.info.type), _.renderComponent(BidConfirm)),//рендер текста соглашения если есть redirectLink
  _.branch(props => (!!props.info.redirectLink && !!props.lot.specialBindingSum), _.renderComponent(LotBidConfirm)),
  _.branch(props => (props.fetching || !props.info), _.renderNothing)
)(BidOverlay)



// WEBPACK FOOTER //
// ./src/components/Lot/Bid.jsx